<div id="mainSidebar" #MainSidebar class="sidebar" (mouseover)='expand();toggleSidebar();'
  (mouseout)='collapse();toggleSidebar();' (click)="hideConfigurationMenu()" *ngIf='actualRoute && !hidden'
  [ngStyle]='{background: sidenavBackground}'>

  <!-- Usuario -->
  <div ngbDropdown class='user-info'>
    <div id="dropdownUser" ngbDropdownToggle>
      <div class="user-button">
        <img src="assets/icons/icon-user-color.png" class='no-sidebar-modifiable'>
      </div>
      <div class="label-name mt-2" style="cursor: pointer;">
        <small>{{(!collapsedSidenav) ? user?.userName : "&nbsp;"}}</small>
      </div>
      <div ngbDropdownMenu aria-labelledby="dropdownUser">
        <button ngbDropdownItem (click)="sendLogout()">Cerrar Sesión</button>
      </div>
    </div>
  </div>

  <br>

  <!-- Book adminstration -->
  <div class="sidenav-button"
    [ngClass]='{"h-expanded":!collapsedSidenav, "active":(actualIconRoute === 0)}'>
    <div class="icon-container align-middle" [routerLink]="['/bookList']">
      <span class='ps-icons icon-book-digital'></span>
      <div class="icon-txt align-middle">
        Gestión de Books
      </div>
    </div>
  </div>
  <br>


  <!-- CONFIGURACIÓN -->
  <div class="sidenav-button"
  *ngIf="showConfigOption"
    [ngClass]='{"h-expanded":!collapsedSidenav, "active":(actualIconRoute === 1)}'>
    <div class="icon-container align-middle" (click)="showConfigNotAvailable()">
      <!--<span class='visor-icons icon-config'></span>-->
      <div class="icon-txt align-middle">
        Configuración
      </div>
    </div>
  </div>
  <br>
  
</div>
  